export type AppNavItemId = 'my-invoices' | 'new-invoice' | 'customers' | 'settings';
export type AppNavVariant = 'top' | 'mobile-bottom';

export interface AppNavItem {
  id: AppNavItemId;
  label: string;
  href: string;
}

export const appNavItems: readonly AppNavItem[] = [
  { id: 'my-invoices', label: 'My Invoices', href: '/' },
  { id: 'new-invoice', label: 'New invoice', href: '/invoices/new' },
  { id: 'customers', label: 'Customers', href: '/counterparties' },
  { id: 'settings', label: 'Settings', href: '/settings' },
] as const;

export function getActiveNavItemId(pathname: string): AppNavItemId | null {
  if (pathname === '/') return 'my-invoices';
  if (pathname === '/invoices/new') return 'new-invoice';
  if (pathname.startsWith('/invoices/')) return 'my-invoices';
  if (pathname === '/counterparties' || pathname.startsWith('/counterparties/')) {
    return 'customers';
  }
  if (pathname === '/settings') return 'settings';
  return null;
}
